"use client";

import { useEffect, useState } from "react";

import { useSession } from "@/stores/session";

/**
 * Persisted auth is merged asynchronously. Until this returns true,
 * treating `token === null` as "signed out" can wrongly redirect /
 * flicker immediately after navigation.
 */
export function useHydratedSession(): boolean {
  const [ready, setReady] = useState(() =>
    typeof window === "undefined" ? false : useSession.persist.hasHydrated(),
  );

  useEffect(() => {
    if (useSession.persist.hasHydrated()) setReady(true);
    const done = (): void => {
      setReady(true);
    };
    return useSession.persist.onFinishHydration(done);
  }, []);

  return ready;
}
